export default function PHP_kill() {
  return (
    <div>
      <h1>PHP_kill</h1>
    </div>
  );
}
